import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function StripeOnboardingReturn() {
  const navigate = useNavigate();
  const { businessId } = useParams();

  useEffect(() => {
    if (!businessId) return;
    navigate(`/business-admin?business_id=${businessId}`, { replace: true });
  }, [businessId, navigate]);

  return (
    <div className="tailwind">
      <div className="flex min-h-[60dvh] w-full flex-col items-center justify-center gap-3 bg-gray-50 px-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-indigo-600" />
        <div className="text-sm text-gray-700">Returning from Stripe…</div>
      </div>
    </div>
  );
}
